import React, { createContext, useContext, useEffect } from "react";
import { useRoles } from "../hooks/useRoles";
import { useAuth } from "./AuthContext";
import { useQuery } from "@tanstack/react-query";

const RoleContext = createContext();

export function RoleProvider({ children }) {
  const { fetchMyRole } = useRoles();
  const { user, isAuthenticated } = useAuth();

  const {
    data: role,
    isLoading: loading,
    error,
  } = useQuery({
    queryKey: ["user-role", user?.id],
    queryFn: fetchMyRole,
    enabled: isAuthenticated && !!user,
    select: (data) => data.data,
  });

  useEffect(() => {
    if (role && !loading) {
      localStorage.setItem("userRole", role);
    }
  }, [role, loading])

  return (
    <RoleContext.Provider value={{ role, loading, error }}>
      {children}
    </RoleContext.Provider>
  );
}

export function useRole() {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return context;
}
